export const VIEW_DATA = {
	TOP_RETAILERS: 'top_retailers',
	AVG_MARKET: 'average_market'
}
